var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 22,
    viewBox: "0 0 82 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82 0H0V18H82V0Z",
    fill: "#FDB714"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 21.8958V18H0L7 21.8958Z",
    fill: "#C3882B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7051 5.46875V14H31.9473L28.5195 8.28125V14H26.7617V5.46875H28.5195L31.9531 11.1934V5.46875H33.7051ZM40.959 12.6289V14H36.418V12.6289H40.959ZM36.9922 5.46875V14H35.2344V5.46875H36.9922ZM40.3672 8.94336V10.2793H36.418V8.94336H40.3672ZM40.9531 5.46875V6.8457H36.418V5.46875H40.9531ZM43.4316 5.46875L45.0371 8.44531L46.6426 5.46875H48.6523L46.1738 9.69922L48.7168 14H46.6895L45.0371 10.9648L43.3848 14H41.3457L43.8945 9.69922L41.4102 5.46875H43.4316ZM53.416 5.46875V14H51.6641V5.46875H53.416ZM56.041 5.46875V6.8457H49.0801V5.46875H56.041Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.6ab0f9d110030ce899cc45adae007c16.svg";
export { ForwardRef as ReactComponent };